import React from 'react';
// import { Product, Organization, BreadcrumbList } from 'schema-dts';

// type SeoSchema = Product | Organization | BreadcrumbList;
interface IProps {
    seoData?: any;
}

const SeoSchema = (props: IProps) => {
    return props.seoData ? (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(props.seoData) }}
        />
    ) : null;
};
export default SeoSchema;
